import type { VanillaEntrance } from './entrance-types';

function e(zone: string, label: string, vanillaTo: string, category: VanillaEntrance['category']): VanillaEntrance {
  return { id: `${zone}::${label}`, zone, label, vanillaTo, category };
}

export const VANILLA_INTERIORS: VanillaEntrance[] = [
  // KF
  e('KF', 'Midos House', 'KF Midos House', 'interior'),
  e('KF', 'Know It All House', 'KF Know It All House', 'interior'),
  e('KF', 'Links House', 'KF Links House', 'interior'),
  e('KF', 'Sarias House', 'KF Sarias House', 'interior'),
  e('KF', 'House of Twins', 'KF House of Twins', 'interior'),
  e('KF', 'Kokiri Shop', 'KF Kokiri Shop', 'interior'),
  // ZD
  e('ZD', 'Shop', 'ZD Shop', 'interior'),
  // ZF
  e('ZF', 'Great Fairy Fountain', 'ZF Great Fairy Fountain', 'interior'),
  // LH
  e('LH', 'Lab', 'LH Lab', 'interior'),
  e('LH', 'Fishing Hole', 'LH Fishing Hole', 'interior'),
  // KAK
  e('KAK', 'Carpenter Boss House', 'Kak Carpenter Boss House', 'interior'),
  e('KAK', 'Bazaar', 'Kak Bazaar', 'interior'),
  e('KAK', 'Potion Shop Front', 'Kak Potion Shop Front', 'interior'),
  e('KAK', 'Potion Shop Back', 'Kak Potion Shop Back', 'interior'),
  e('KAK', 'Odd Medicine Building', 'Kak Odd Medicine Building', 'interior'),
  e('KAK', 'Windmill', 'Kak Windmill', 'interior'),
  e('KAK', 'Impas House Back', 'Kak Impas House Back', 'interior'),
  e('KAK', 'Impas House', 'Kak Impas House', 'interior'),
  e('KAK', 'Shooting Gallery', 'Kak Shooting Gallery', 'interior'),
  e('KAK', 'House of Skulltula', 'Kak House of Skulltula', 'interior'),
  // GY
  e('GY', 'Dampes House', 'Graveyard Dampes House', 'interior'),
  // GV
  e('GV', 'Carpenter Tent', 'GV Carpenter Tent', 'interior'),
  // DCol
  e('DCol', 'Great Fairy Fountain', 'Colossus Great Fairy Fountain', 'interior'),
  // HC
  e('HC', 'Great Fairy Fountain', 'HC Great Fairy Fountain', 'interior'),
  // OGC
  e('OGC', 'Great Fairy Fountain', 'OGC Great Fairy Fountain', 'interior'),
  // MKT
  e('MKT Bridge', 'Guard House', 'Market Guard House', 'interior'),
  e('MKT', 'Bazaar', 'Market Bazaar', 'interior'),
  e('MKT', 'Potion Shop', 'Market Potion Shop', 'interior'),
  e('MKT', 'Temple of Time', 'Temple of Time', 'interior'),
  e('MKT', 'Mask Shop', 'Market Mask Shop', 'interior'),
  e('MKT', 'Shooting Gallery', 'Market Shooting Gallery', 'interior'),
  e('MKT', 'Bombchu Bowling', 'Market Bombchu Bowling', 'interior'),
  e('MKT', 'Treasure Chest Game', 'Market Treasure Chest Game', 'interior'),
  e('MKT', 'Bombchu Shop', 'Market Bombchu Shop', 'interior'),
  e('MKT', 'Man in Green House', 'Market Man in Green House', 'interior'),
  // LLR
  e('LLR', 'Talons House', 'LLR Talons House', 'interior'),
  e('LLR', 'Stables', 'LLR Stables', 'interior'),
  e('LLR', 'Tower', 'LLR Tower', 'interior'),
  // DMT
  e('DMT', 'Great Fairy Fountain', 'DMT Great Fairy Fountain', 'interior'),
  // DMC
  e('DMC', 'Great Fairy Fountain', 'DMC Great Fairy Fountain', 'interior'),
  // GC
  e('GC', 'Shop', 'GC Shop', 'interior'),
];

export const VANILLA_GROTTOS: VanillaEntrance[] = [
  // KF
  e('KF', 'Storms Grotto', 'KF Storms Grotto', 'grotto'),
  // LW
  e('LW', 'Near Shortcuts Grotto', 'LW Near Shortcuts Grotto', 'grotto'),
  e('LW', 'Scrubs Grotto', 'LW Scrubs Grotto', 'grotto'),
  e('LW', 'Deku Theater', 'Deku Theater', 'grotto'),
  // SFM
  e('SFM', 'Wolfos Grotto', 'SFM Wolfos Grotto', 'grotto'),
  e('SFM', 'Fairy Grotto', 'SFM Fairy Grotto', 'grotto'),
  e('SFM', 'Storms Grotto', 'SFM Storms Grotto', 'grotto'),
  // ZR
  e('ZR', 'Storms Grotto', 'ZR Storms Grotto', 'grotto'),
  e('ZR', 'Open Grotto', 'ZR Open Grotto', 'grotto'),
  e('ZR', 'Fairy Grotto', 'ZR Fairy Grotto', 'grotto'),
  // ZD
  e('ZD', 'Storms Grotto', 'ZD Storms Grotto', 'grotto'),
  // LH
  e('LH', 'Grotto', 'LH Grotto', 'grotto'),
  // KAK
  e('KAK', 'Open Grotto', 'Kak Open Grotto', 'grotto'),
  e('KAK', 'Redead Grotto', 'Kak Redead Grotto', 'grotto'),
  // GY
  e('GY', 'Shield Grave', 'Graveyard Shield Grave', 'grotto'),
  e('GY', 'Dampes Grave', 'Graveyard Dampes Grave', 'grotto'),
  e('GY', 'Heart Piece Grave', 'Graveyard Heart Piece Grave', 'grotto'),
  e('GY', 'Royal Familys Tomb', 'Graveyard Royal Familys Tomb', 'grotto'),
  // GV
  e('GV', 'Storms Grotto', 'GV Storms Grotto', 'grotto'),
  e('GV', 'Octorok Grotto', 'GV Octorok Grotto', 'grotto'),
  // GF
  e('GF', 'Storms Grotto', 'GF Storms Grotto', 'grotto'),
  // DCol
  e('DCol', 'Grotto', 'Colossus Grotto', 'grotto'),
  // HC
  e('HC', 'Storms Grotto', 'HC Storms Grotto', 'grotto'),
  // HF
  e('HF', 'Near Market Grotto', 'HF Near Market Grotto', 'grotto'),
  e('HF', 'Tektite Grotto', 'HF Tektite Grotto', 'grotto'),
  e('HF', 'Southeast Grotto', 'HF Southeast Grotto', 'grotto'),
  e('HF', 'Near Kak Grotto', 'HF Near Kak Grotto', 'grotto'),
  e('HF', 'Open Grotto', 'HF Open Grotto', 'grotto'),
  e('HF', 'Inside Fence Grotto', 'HF Inside Fence Grotto', 'grotto'),
  e('HF', 'Fairy Grotto', 'HF Fairy Grotto', 'grotto'),
  e('HF', 'Cow Grotto', 'HF Cow Grotto', 'grotto'),
  // LLR
  e('LLR', 'Grotto', 'LLR Grotto', 'grotto'),
  // DMT
  e('DMT', 'Storms Grotto', 'DMT Storms Grotto', 'grotto'),
  e('DMT', 'Cow Grotto', 'DMT Cow Grotto', 'grotto'),
  // DMC
  e('DMC', 'Hammer Grotto', 'DMC Hammer Grotto', 'grotto'),
  e('DMC', 'Upper Grotto', 'DMC Upper Grotto', 'grotto'),
  // GC
  e('GC', 'Grotto', 'GC Grotto', 'grotto'),
];

export const VANILLA_DUNGEONS: VanillaEntrance[] = [
  e('KF', 'Deku Tree', 'Deku Tree Lobby', 'dungeon'),
  e('DMT', 'Dodongos Cavern', 'Dodongos Cavern Beginning', 'dungeon'),
  e('ZF', 'Jabu Jabus Belly', 'Jabu Jabus Belly Beginning', 'dungeon'),
  e('SFM', 'Forest Temple', 'Forest Temple Lobby', 'dungeon'),
  e('DMC', 'Fire Temple', 'Fire Temple Lower', 'dungeon'),
  e('LH', 'Water Temple', 'Water Temple Lobby', 'dungeon'),
  e('GY', 'Shadow Temple', 'Shadow Temple Entryway', 'dungeon'),
  e('DCol', 'Spirit Temple', 'Spirit Temple Lobby', 'dungeon'),
  e('ZF', 'Ice Cavern', 'Ice Cavern Beginning', 'dungeon'),
  e('KAK', 'Bottom of the Well', 'Bottom of the Well', 'dungeon'),
  e('GF', 'Gerudo Training Ground', 'Gerudo Training Ground Lobby', 'dungeon'),
  e('OGC', 'Ganons Castle', 'Ganons Castle Lobby', 'dungeon'),
];

export const VANILLA_BOSS_ROOMS: VanillaEntrance[] = [
  e('KF', 'Deku Tree => Gohma', 'Queen Gohma Boss Room', 'boss'),
  e('DMT', 'Dodongos Cavern => King Dodongo', 'King Dodongo Boss Room', 'boss'),
  e('ZF', 'Jabu Jabus Belly => Barinade', 'Barinade Boss Room', 'boss'),
  e('SFM', 'Forest Temple => Phantom Ganon', 'Phantom Ganon Boss Room', 'boss'),
  e('DMC', 'Fire Temple => Volvagia', 'Volvagia Boss Room', 'boss'),
  e('LH', 'Water Temple => Morpha', 'Morpha Boss Room', 'boss'),
  e('GY', 'Shadow Temple => Bongo Bongo', 'Bongo Bongo Boss Room', 'boss'),
  e('DCol', 'Spirit Temple => Twinrova', 'Twinrova Boss Room', 'boss'),
  e('OGC', 'Ganons Castle => Ganons Tower', 'Ganons Castle Tower', 'boss'),
];

export const VANILLA_OVERWORLD: VanillaEntrance[] = [
  // KF
  e('KF', 'KF => LW', 'Lost Woods', 'overworld'),
  e('KF', 'KF => LW Bridge', 'LW Bridge From Forest', 'overworld'),
  // LW
  e('LW', 'LW => GC', 'GC Woods Warp', 'overworld'),
  e('LW', 'LW => SFM', 'SFM Entryway', 'overworld'),
  e('LW', 'LW => KF', 'Kokiri Forest', 'overworld'),
  e('LW', 'LW => ZR', 'Zora River', 'overworld'),
  // SFM
  e('SFM', 'SFM => LW', 'LW Beyond Mido', 'overworld'),
  // HF
  e('HF', 'HF => ZR', 'Zora River', 'overworld'),
  e('HF', 'HF => KAK', 'Kakariko Village', 'overworld'),
  e('HF', 'HF => Market', 'Market Entrance', 'overworld'),
  e('HF', 'HF => GV', 'Gerudo Valley', 'overworld'),
  e('HF', 'HF => LH', 'Lake Hylia', 'overworld'),
  e('HF', 'HF => LLR', 'Lon Lon Ranch', 'overworld'),
  e('HF', 'HF => LW Bridge', 'LW Bridge', 'overworld'),
  // MKT
  e('MKT', 'Market => HC', 'Castle Grounds', 'overworld'),
  e('MKT', 'Market => ToT', 'ToT Entrance', 'overworld'),
  e('MKT', 'Market => Bridge', 'Market Entrance', 'overworld'),
  e('MKT', 'ToT => Market', 'Market', 'overworld'),
  e('HC', 'HC => Market', 'Market', 'overworld'),
  // LLR
  e('LLR', 'LLR => HF', 'Hyrule Field', 'overworld'),
  // KAK
  e('KAK', 'KAK => HF', 'Hyrule Field', 'overworld'),
  e('KAK', 'KAK => DMT', 'Death Mountain', 'overworld'),
  e('KAK', 'KAK => GY', 'Graveyard', 'overworld'),
  // GY
  e('GY', 'GY => KAK', 'Kakariko Village', 'overworld'),
  // DMT
  e('DMT', 'DMT => KAK', 'Kakariko Village', 'overworld'),
  e('DMT', 'DMT => GC', 'Goron City', 'overworld'),
  e('DMT', 'DMT => DMC', 'DMC Upper Local', 'overworld'),
  // DMC
  e('DMC', 'DMC => DMT', 'Death Mountain Summit', 'overworld'),
  e('DMC', 'DMC => GC', 'GC Darunias Chamber', 'overworld'),
  // GC
  e('GC', 'GC => DMC', 'DMC Lower Local', 'overworld'),
  e('GC', 'GC => LW', 'Lost Woods', 'overworld'),
  e('GC', 'GC => DMT', 'Death Mountain', 'overworld'),
  // ZR
  e('ZR', 'ZR => HF', 'Hyrule Field', 'overworld'),
  e('ZR', 'ZR => LW', 'Lost Woods', 'overworld'),
  e('ZR', 'ZR => ZD', 'Zoras Domain', 'overworld'),
  // ZD
  e('ZD', 'ZD => ZR', 'Zora River', 'overworld'),
  e('ZD', 'ZD => LH', 'Lake Hylia', 'overworld'),
  e('ZD', 'ZD => ZF', 'Zoras Fountain', 'overworld'),
  // ZF
  e('ZF', 'ZF => ZD', 'Zoras Domain', 'overworld'),
  // LH
  e('LH', 'LH => ZD', 'Zoras Domain', 'overworld'),
  e('LH', 'LH => HF', 'Hyrule Field', 'overworld'),
  // GV
  e('GV', 'GV => HF', 'Hyrule Field', 'overworld'),
  e('GV', 'GV => LH (stream)', 'Lake Hylia', 'overworld'),
  e('GV', 'GV => GF', 'Gerudo Fortress', 'overworld'),
  // GF
  e('GF', 'GF => GV', 'GV Fortress Side', 'overworld'),
  e('GF', 'GF => Wasteland', 'Wasteland Near Fortress', 'overworld'),
  // Wasteland
  e('Wasteland', 'Wasteland => GF', 'GF Outside Gate', 'overworld'),
  e('Wasteland', 'Wasteland => DCol', 'Desert Colossus', 'overworld'),
  // DCol
  e('DCol', 'DCol => Wasteland', 'Wasteland Near Colossus', 'overworld'),
];

export const VANILLA_WARPS: VanillaEntrance[] = [
  e('Warps', 'Minuet of Forest', 'Sacred Forest Meadow', 'warp'),
  e('Warps', 'Bolero of Fire', 'DMC Central Local', 'warp'),
  e('Warps', 'Serenade of Water', 'Lake Hylia', 'warp'),
  e('Warps', 'Nocturne of Shadow', 'Graveyard Warp Pad Region', 'warp'),
  e('Warps', 'Requiem of Spirit', 'Desert Colossus', 'warp'),
  e('Warps', 'Prelude of Light', 'Temple of Time', 'warp'),
];

export const VANILLA_SPAWNS: VanillaEntrance[] = [
  e('Spawns', 'Child Spawn', 'KF Links House', 'spawn'),
  e('Spawns', 'Adult Spawn', 'Temple of Time', 'spawn'),
];

export const VANILLA_OWLS: VanillaEntrance[] = [
  e('Owls', 'DMT Owl Flight', 'Kak Impas Rooftop', 'owl'),
  e('Owls', 'LH Owl Flight', 'Hyrule Field', 'owl'),
];

export const VANILLA_LW_BRIDGE: VanillaEntrance[] = [
  e('LW Bridge', 'LW Bridge => KF', 'Kokiri Forest', 'overworld'),
  e('LW Bridge', 'LW Bridge => HF', 'Hyrule Field', 'overworld'),
];

export const VANILLA_MKT_BRIDGE: VanillaEntrance[] = [
  e('MKT Bridge', 'Bridge => HF', 'Hyrule Field', 'overworld'),
  e('MKT Bridge', 'Bridge => Market', 'Market', 'overworld'),
];

export const VANILLA_POTION_SHOP: VanillaEntrance[] = [
  e('Potion Shop', 'Potion Front Interior', 'Potion Front Exit', 'interior'),
  e('Potion Shop', 'Potion Back Interior', 'Potion Back Exit', 'interior'),
  e('Potion Shop', 'Potion Shop', 'Shop', 'interior'),
];

// Warp pads: destination-only (Warps, Spawns, Owls can point here)
export const VANILLA_PADS: VanillaEntrance[] = [
  e('GY', 'GY Pad', 'Graveyard Warp Pad Region', 'warp'),
  e('SFM', 'SFM Pad', 'Sacred Forest Meadow', 'warp'),
  e('DMC', 'DMC Pad', 'DMC Central Local', 'warp'),
  e('LH', 'Lake Pad', 'Lake Hylia', 'warp'),
  e('DCol', 'Colossus Pad', 'Desert Colossus', 'warp'),
];

export const PAD_IDS = new Set(VANILLA_PADS.map(p => p.id));

export const ALL_VANILLA_ENTRANCES: VanillaEntrance[] = [
  ...VANILLA_OVERWORLD,
  ...VANILLA_LW_BRIDGE,
  ...VANILLA_MKT_BRIDGE,
  ...VANILLA_POTION_SHOP,
  ...VANILLA_INTERIORS,
  ...VANILLA_GROTTOS,
  ...VANILLA_DUNGEONS,
  ...VANILLA_BOSS_ROOMS,
  ...VANILLA_PADS,
  ...VANILLA_WARPS,
  ...VANILLA_SPAWNS,
  ...VANILLA_OWLS,
];

/** All possible destination names (for autocomplete) */
export const ALL_DESTINATION_NAMES: string[] = (() => {
  const set = new Set<string>();
  for (const ent of ALL_VANILLA_ENTRANCES) {
    set.add(ent.vanillaTo);
  }
  return Array.from(set).sort();
})();
